function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightningSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 400 400",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F7CF52"
    },
    points: "157.055,0 90.798,196.319 164.417,196.319 88.344,400 289.571,159.509 218.405,159.509  311.656,0  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightningSvgrepoCom);
export default __webpack_public_path__ + "static/media/lightning-svgrepo-com.bff8bd9e0f43dcc8aa4e2ecd81ccd09b.svg";
export { ForwardRef as ReactComponent };